import type {
  TSerial,
  TAvailableLanguage
} from '@langedit/backend/definitions'

import type {
  TSubject,
  TDifficulty,
  TYearPeriod,
  TChildrenGrade,
  TMessagingQueue,
  TAvailablePlatform
} from '../common/definitions'

import type { TGrouppedLabelTypes } from './types/labels'

export type {
  TSerial,
  TAvailableLanguage
}

export type {
  TLanguageParts,
  ISetPartsRequest,
  IAppKeyWithAppId,
  TAppKeyWithAppIds,
  IAppKeyWithSerial,
  TTranslatedAppKeys,
  TAppKeysWithSerials,
  IDeleteAppKeysModuleServiceRequest,
  IGetAppKeysValuesBySerialModuleServiceRequest,
  IGetAppKeysValuesBySerialModuleServiceResponse
} from '@langedit/backend/definitions'

export type {
  IRawLevelOption,
  TRawLevelOptions,
  TLevelOptionValue,
  TLevelCombinations,
  IBaseRawLevelOption,
  ILevelOptionCombinations
} from '@apps/testers/levelCombinationsCollector/definitions'

export type { IPaginationRequest, IPaginationResponse } from './types/common'

export {
  SUBJECTS,
  EBindValue,
  DIFFICULTIES,
  PLATFORM_LANGS,
  DEFAULT_LANGUAGE_VALUE,
  AVAILABILITY_FLAG_NUMBERS,
  SELECTABLE_CHILDREN_GRADES,
  APP_IDS_WITHOUT_LEVEL_SELECTOR
} from '../common/definitions'

export type {
  TBool,
  TSelectableChildrenGrade
} from '../common/definitions'

export type {
  TAppsMap,
  IWholeApp,
  TWholeApps,
  IMinimalApp,
  TMinimalApps,
  TAppTitlesMap,
  IResetByAppIdRequest,
  IWholeAppsFinderFilter,
  IWholeAppsFinderRequest,
  ISearchWholeAppsResponse,
  IWholeAppsFinderInitResponse,
  IGetModuleableAppIdsResponse,
  TWholeAppFinderGradeDifficulties,
  IWholeAppsOnlyWithModulesRequest
} from './types/apps'

export {
  ELabelsRoute,
  ERoutesRoute,
  EStatusRoute,
  EModulesRoute,
  ELabelingRoute,
  EWholeAppsRoute,
  EUserRoutesRoute,
  ERouteLabelsRoute,
  ELevelOptionsRoute,
  EModuleFinderRoute,
  EModuleImagesRoute,
  EExperienceSpaceRoute,
  EAppDescriptionsRoute,
  EGeneratedRoutesRoute,
  EFavouriteModulesRoute
} from './types/endpoints'

export {
  ELevelOptionType
} from './types/levelOptions'

export type {
  ILevelOption,
  TLevelOptions,
  INewLevelOption,
  TNewLevelOptions,
  ILevelOptionsData,
  IUpdateLevelOption,
  TActiveLevelOptions,
  IAncientLevelOption,
  TBaseRawLevelOptions,
  TAncientLevelOptions,
  IModularInitResponse,
  IBaseActiveLevelOption,
  TTranslatedLevelOptions,
  TBaseActiveLevelOptions,
  IUpdateLevelOptionRequest,
  IAdvancedAncientLevelOption,
  TActiveLevelOptionsBySerial,
  IGetResourceStringsResponse,
  IGetLevelOptionByIdResponse,
  TAdvancedAncientLevelOptions,
  IGetLevelOptionsByAppIdResponse,
  IGetTranslatedLevelOptionsByParams,
  IGetActiveLevelOptionsBySerialResponse,
  IGetModuleIdByAncientLevelOptionsRequest,
  IGetModuleIdByAncientLevelOptionsResponse,
  IGetLevelOptionsBySerialAndModuleIdRequest,
  IGetLevelOptionCombinationsBySerialResponse,
  IGetLevelOptionsBySerialAndModuleIdResponse,
  IGetPossibleModuleBySerialAndLevelOptionsRequest
} from './types/levelOptions'

export type {
  ILabel,
  TLabels,
  IBaseLabel,
  TLabelType,
  IRouteLabel,
  TRouteLabels,
  TModuleLabels,
  TGradePeriods,
  TTranslationMap,
  ILabelingRequest,
  TBaseModuleLabels,
  TThemeLabelCounts,
  TLabelTranslations,
  IGetLabelsResponse,
  TRouteGradePeriods,
  IUpdateLabelRequest,
  IInsertLabelRequest,
  TGrouppedLabelTypes,
  IGetLabelByIdResponse,
  TRouteThemeLabelCounts,
  TLabelTypesByModuleIds,
  TTranslatedGradePeriods,
  IGetGradePeriodsResponse,
  IGetLabelsEditorDataResponse,
  IModuleFinderGetLabelsResponse
} from './types/labels'

export {
  LABEL_TYPES,
  POSSIBLE_LABEL_PARENT_TYPES
} from './types/labels'

export {
  EIsFavourite,
  MODULE_AVAILABILITY_SCOPES
} from './types/modules'

export type {
  IModule,
  TModules,
  TNewModules,
  IModuleImage,
  IAdminModule,
  IUpdateModule,
  TRouteModules,
  TModuleImages,
  TAdminModules,
  TRandomModules,
  TMinimalModules,
  INewModuleImage,
  IFavouriteModule,
  IBaseModuleImage,
  TBaseRouteModules,
  IModuleLevelOption,
  IGetModulesRequest,
  IModuleTranslation,
  IModularInitRequest,
  TModuleLevelOptions,
  IIsFavouriteRequest,
  IGetModulesResponse,
  IBaseFavouriteModule,
  IIsFavouriteResponse,
  IGetModuleByIdRequest,
  IGetModuleByIdResponse,
  TRouteModulesWithAppIds,
  IToggleFavouriteRequest,
  IToggleFavouriteResponse,
  TModuleAvailabilityScope,
  IIInsertModuleTranslation,
  TInsertModuleTranslations,
  IGetModulesDetailsRequest,
  IGetSearchPreviewResponse,
  IGetModulesByAppIdResponse,
  IGetModulesDetailsResponse,
  IModuleFinderSearchRequest,
  IGetModulesBySearchResponse,
  IGetModulesByUserIdentifier,
  IModuleTranslationIdentifier,
  IAppDescriptionUpdateRequest,
  IGetModulesByModuleIdsResponse,
  IGetUserFavouriteModulesReponse,
  ISetModuleAvailabilitiesRequest,
  ISaveAndSendGeneratedRouteRequest,
  IModuleFinderPaginationSearchRequest,
  IGenerateRecommendableModulesResponse,
  IGetRandomModulesByThemeAndGradeRequest,
  IGetRandomModulesByThemeAndGradeResponse,
  IGetModuleBySerialAndLevelOptionsResponse
} from './types/modules'

export type {
  IRoute,
  TRoutes,
  IBaseRoute,
  IInsertRoute,
  IUpdateRoute,
  IDigestRoute,
  IRouteDetails,
  TRouteDetails,
  ILevelCheckerRoute,
  TLevelCheckerRoutes,
  IGetDigestRouteById,
  IMinimalRouteDetails,
  IRouteWithModuleCount,
  IGetRouteByIdResponse,
  IInsertNewLevelChecker,
  IGetLevelCheckerParams,
  IGetUserRoutesResponse,
  TRoutesWithModuleCounts,
  IInsertUserRouteRequest,
  IUpdateUserRouteRequest,
  ILevelCheckerRouteFilter,
  IInsertUserRouteResponse,
  IGetRoutesDetailsResponse,
  IMinimalLevelCheckerRoute,
  TMinimalLevelCheckerRoutes,
  IInsertLevelCheckerRequest,
  IHasGeneratedRouteResponse,
  IExperienceSpaceModuleInfo,
  ISetRouteNotEditableRequest,
  TExperienceSpaceModuleInfos,
  IExperienceSpaceInitResponse,
  IGetRoutesDetailsByIdsRequest,
  IDeleteUserRoutesByIdsRequest,
  IGetRoutesDetailsByIdsResponse,
  IGetLevelCheckerRoutesResponse,
  IGetMatchingLevelCheckerResponse,
  ICreateRouteByThemeAndGradeRequest,
  ICreateRouteByThemeAndGradeResponse,
  IGetLevelCheckersByGradePeriodRequest,
  IGetLevelCheckersByGradePeriodResponse
} from './types/routes'

export { ERouteOptionFlag } from './types/routes'

export type {
  TSubject,
  TDifficulty,
  TYearPeriod,
  TChildrenGrade,
  TAvailablePlatform
}

export enum ECacheKey {
  AppTitles = 'AppTitles'
}

export enum EState {
  Active   = 1,
  Inactive = 0
}

export const DEFAULT_ROUTE_MODULE_COUNT = 10

export interface IModuleCount {
  readonly appId: number
  readonly state: number
  readonly count: number
}

export type TModuleCounts = readonly IModuleCount[]

export interface IBaseAppModuleCountInfo {
  /** Aktivált modulok száma. */
  readonly activeModuleCount: number
  /** Inaktivált modulok száma. */
  readonly inactiveModuleCount: number
}

export type TProcessedModuleCountInfos = TReadonlyRecord<number, IBaseAppModuleCountInfo>

export interface IAppModuleCountInfo extends IBaseAppModuleCountInfo {
  /** Az adott app szériaszáma. */
  readonly serial: TSerial
  /** Összes modul. */
  readonly moduleCount: number
}

export type TAppModuleCountInfos = readonly IAppModuleCountInfo[]

export interface IGetModuleCountInfoResponse {
  readonly infos: TAppModuleCountInfos
  readonly summary: {
    readonly appCount: number
    readonly moduleCount: number
    readonly appsWithModules: number
    readonly activeModuleCount: number
    readonly appsWithNoModules: number
    readonly inactiveModuleCount: number
    readonly appsWithAllActiveModules: number
    readonly appsWithAllInactiveModules: number
  } | null
}

export interface IGetAppDescriptionByModuleIdResponse {
  /** A modulhoz tartozó kép elérési útvonala, ha van elérhető kép. */
  readonly imagePath: string | null
  /** A modul címe, ha van ilyen beállítva a célplatformon. */
  readonly title: string | null
  /** A modul leírása, ha van ilyen beállítva a célplatformon. */
  readonly description: string | null
  /** A tartalmazó app szériaszáma. */
  readonly serial: TSerial
  /** Az adott modulhoz tartozó címkék, típus szerint csoportosítva. */
  readonly labels: TGrouppedLabelTypes
}

export interface IModuleImagesInsertBase64ImageRequest {
  readonly appId: number
  readonly levelOptionId: number | null
  readonly base64image: string
  readonly availabilityFlags: number
}

/** Ez egyből törölhető, amint megszűnt a statService-es csoportok szerinti stat. */
export interface IModuleInfo {
  readonly moduleId: number
  readonly subjects: readonly number[]
  readonly devAreas: readonly number[]
}

export type TModuleInfos = readonly IModuleInfo[]

export interface IGetModuleInfosRequest {
  readonly moduleIds: readonly number[]
  readonly platform: TAvailablePlatform
}

export interface IGetModuleInfosResponse {
  readonly infos: TModuleInfos
  readonly labelTitles: Record<number, string>
}

/** Modulhoz tartozó kép beszúrásához tartozó adatok. */
export interface IModuleInsertByUploadRequest {
  readonly moduleId: number
  readonly platform: TAvailablePlatform
}

/** Modulhoz tartozó base64 kép feltöltése. */
export interface IModuleInsertByBase64Request extends IModuleInsertByUploadRequest {
  readonly base64: string
}

/** Idáig törölhető. */

/** Azon üzenetsorok, amelyeknél a szolgáltatás, mint producer van jelen. */
const LOCAL_PRODUCER_QUEUES = [
  'RouteNameChanged',
  'ModuleImageChanged',
  'ModuleDescriptionChanged'
] as const satisfies TMessagingQueue[]

export const PRODUCER_QUEUES: TReadonlyRecord<typeof LOCAL_PRODUCER_QUEUES[number], TMessagingQueue> = {
  /* eslint-disable @typescript-eslint/naming-convention */
  RouteNameChanged: 'RouteNameChanged',
  ModuleImageChanged: 'ModuleImageChanged',
  ModuleDescriptionChanged: 'ModuleDescriptionChanged'
  /* eslint-enable @typescript-eslint/naming-convention */
}
